import { FC } from "react";

interface CheckboxInactiveSvgProps {
  size?: number;
}

const CheckboxInactiveSvg: FC<CheckboxInactiveSvgProps> = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1.5" y="1.5" width="17" height="17" rx="4.5" stroke="#7D8690" />
  </svg>
);

export default CheckboxInactiveSvg;
